import globalNavigationMixin from '@@/mixins/globalNavigation.js';

export default defineNuxtPlugin(({vueApp})=>{
  vueApp.mixin(globalNavigationMixin);
})
